export default __webpack_public_path__ + "static/media/Backend.6233d29b.png";